import {
  generatePath, LoaderFunctionArgs, matchPath, redirect,
} from 'react-router-dom';

type GuardedPage = {
  path: string;
  redirectTo: string;
};

const CAMPAIGN_SUMMARY = '/:teamId/campaign/:campaignId/summary';
const ITERATION_SUMMARY = '/:teamId/campaign/:campaignId/iteration/:iterationId/summary';
const TEAM_MESSAGE_PLANS = '/admin/:teamId/team-message-plans';

// Pages that only make sense as part of a journey and must not be loaded directly via the URL
export const GUARDED_PAGES: GuardedPage[] = [
  { path: '/admin/:teamId/team-cohorts/confirmation', redirectTo: '/admin/:teamId/team-cohorts' },
  { path: '/admin/:teamId/team-message-plans/change-targets/confirmation', redirectTo: TEAM_MESSAGE_PLANS },
  { path: '/admin/:teamId/team-message-plans/confirmation', redirectTo: TEAM_MESSAGE_PLANS },
  { path: '/:teamId/campaign/:campaignId/iteration/:iterationId/archive-iteration-confirmation', redirectTo: ITERATION_SUMMARY },
  { path: '/:teamId/campaign/:campaignId/iteration/:iterationId/key-details/confirmation', redirectTo: ITERATION_SUMMARY },
  { path: '/:teamId/campaign/:campaignId/iteration/:iterationId/message-plans-updated', redirectTo: ITERATION_SUMMARY },
  { path: '/:teamId/campaign/:campaignId/iteration/:iterationId/select-run-type', redirectTo: ITERATION_SUMMARY },
  { path: '/:teamId/campaign/:campaignId/iteration/:iterationId/summary-report-requested', redirectTo: ITERATION_SUMMARY },
  { path: '/:teamId/campaign/:campaignId/key-details/confirmation', redirectTo: CAMPAIGN_SUMMARY },
];

export const directAccessGuardLoader = ({ request }: LoaderFunctionArgs): Response | null => {
  const { pathname } = new URL(request.url);

  const redirectPath = GUARDED_PAGES
    .map(({ path, redirectTo }) => {
      const match = matchPath(path, pathname);
      if (match) {
        return generatePath(redirectTo, match.params);
      }

      return null;
    })
    .find((guardedRedirect) => guardedRedirect !== null);

  if (redirectPath) {
    return redirect(redirectPath);
  }

  return null;
};
